import { SyntheticPlatformEmitter } from "expo-modules-core";

// Ensure events are sent so custom Fast Refresh views are shown.
function showMessage(message: string, type: "load" | "refresh") {
  SyntheticPlatformEmitter.emit("devLoadingView:showMessage", {
    message,
  });
}

function hide() {
  SyntheticPlatformEmitter.emit("devLoadingView:hide", {});
}

function dismissBuildError() {
  // TODO: Add a proper dismiss build error from react-error-overlay
  // in RN they use LogBox but this is pretty wild for web.
  // console.clear();
}

module.exports = {
  showMessage,
  hide,
  dismissBuildError,
};

export default {
  showMessage,
  hide,
  dismissBuildError,
};
